
<div :class="classes"
  class="word-wrap"
  :style="{'width': tableBodyWidth}"
  role="table"
>
  <template v-if="hasHeader">
    <row-group class="table-header">
      <t-row is-heading>
        <slot name="table-header"></slot>
      </t-row>
    </row-group>
  </template>

  <row-group class="table-body">
    <template v-if="hasData">
      <slot name="table-body"></slot>
    </template>

    <template v-else>
      <template v-if="$slots['fetching-message']">
        <slot name="fetching-message"></slot>
      </template>
      <t-row class="prompt" v-else>
        <t-column>
          <strong>{{fetchingMessage}}</strong>
        </t-column>
      </t-row>
    </template>
  </row-group>

  <template v-if="hasFooter || $slots['table-footer']">
    <row-group class="table-footer">
      <slot name="table-footer"></slot>
    </row-group>
  </template>

</div>
